import { useContext, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ScreensRouter from "../containers/ScreensRouter";
import Login from "../containers/Login";
import './style.css'
import { Context } from "../context";
import ForgetPasswordCode from "src/containers/Login/ForgetPasswordCode";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ResetPasswordC from "src/containers/Login/ResetPasswordC";
import ErrorScreenGuard from "src/component/ErrorScreenGuard";
import TwoFactorAuthentication from "src/containers/Login/TwoFactorAuthentication";
import HisEmbed from "src/containers/HisEmbed";
import HisTestPage from "src/containers/HisTestPage";
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITEKEY;

const RoutesC = () => {
  const { isLoggedIn, systemIsHealthy, fetchHealth, hasNetworkConnection } = useContext(Context);
  const { pathname } = useLocation();

  useEffect(() => {
    fetchHealth();
  }, [pathname, fetchHealth]);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey || ""}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'body'
      }}
    >
      <ErrorScreenGuard
        systemIsHealthy={systemIsHealthy}
        hasNetworkConnection={hasNetworkConnection}
      >
        <Routes>
          <Route path="login" element={!isLoggedIn ? <Login /> : <Navigate to="/" />} />
          <Route path="two-factor-auth" element={!isLoggedIn ? <TwoFactorAuthentication /> : <Navigate to="/" />} />
          <Route path="passwordCode" element={!isLoggedIn ? <ForgetPasswordCode /> : <Navigate to="/" />} />
          <Route path="reset-Password" element={!isLoggedIn ? <ResetPasswordC /> : <Navigate to="/" />} />
          <Route path="his-embed" element={<HisEmbed />} />
          <Route path="his-test" element={<HisTestPage />} />
          <Route path="/*" element={isLoggedIn ? <ScreensRouter /> : <Navigate to="/login" />} />
        </Routes>
      </ErrorScreenGuard>
    </GoogleReCaptchaProvider>
  );
};

export default RoutesC;